import React, { useState } from "react";
import "./Contact.css";
import contactusimg from "../../../assets/contactusimg.png";
import Footer from "../../Footer/Footer";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    enquiry: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email address";
    }
    if (!formData.enquiry.trim()) newErrors.enquiry = "Enquiry is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      console.log("Form submitted:", formData);
      alert("Message sent successfully!");
      setFormData({ name: "", email: "", enquiry: "" });
      setErrors({});
    }
  };

  return (
    <>
      <div>
        {/* Banner */}
        <div className="contact-banner">
          <img
            src={contactusimg}
            alt="Contact Banner"
            className="contact-banner-img"
          />
          <div className="contact-banner-text">
            <h1>Contact Us</h1>
          </div>
        </div>

        {/* Combined Contact Section */}
        <div className="contact-section-page">
          <div className="contact-combined-container">
            {/* Contact Info */}
            <div className="contact-section-info">
              <h2>Contact Information</h2>
              <div className="contact-section-info-item">
                <i className="fas fa-phone-alt"></i>
                <div>
                  <strong>Call Us:</strong>
                  <br />
                  <a
                    href="tel:9063488659"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                     9063488659
                  </a>
                </div>
              </div>
              <hr />
              <div className="contact-section-info-item">
                <i className="fas fa-envelope"></i>
                <div>
                  <strong>Email:</strong>
                  <br />
                  <a
                    href="mailto:bd@varanouslabs.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    bd@varanouslabs.com
                  </a>
                </div>
              </div>
              <hr />
              <div className="contact-section-info-item">
                <i className="fas fa-comment-dots"></i>
                <div>
                  <strong>Chat with Us:</strong>
                  <br />
                  <a
                    href="https://wa.me/91- 9063488659."
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    91-9063488659
                  </a>
                </div>
              </div>
              <hr />
              <div className="contact-section-info-item">
                <i className="fas fa-video"></i>
                <div>
                  <strong>Meeting With Us:</strong>
                  <br />
                  <a
                    href="https://zoom.us/join"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    Schedule a Meeting
                  </a>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-section-form">
              <h2>Let's Connect</h2>
              <form onSubmit={handleSubmit} noValidate>
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                  {errors.name && (
                    <span className="error-text">{errors.name}</span>
                  )}
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  {errors.email && (
                    <span className="error-text">{errors.email}</span>
                  )}
                </div>
                <div className="form-group">
                  <textarea
                    name="enquiry"
                    placeholder="Enter your enquiry"
                    value={formData.enquiry}
                    onChange={handleChange}
                    required
                  />
                  {errors.enquiry && (
                    <span className="error-text">{errors.enquiry}</span>
                  )}
                </div>
                <button type="submit" className="contact-submit-btn">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;